let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lSk2O")).then(() => parcelRequire('dnBrI'));